var map = {
	"./en.json": [
		94092,
		"src_apps_clos-sessions_guards_translation_translations_en_json"
	],
	"./ru.json": [
		68821,
		"src_apps_clos-sessions_guards_translation_translations_ru_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 56092;
module.exports = webpackAsyncContext;